import React from 'react';
import { Link } from 'react-router-dom';

export default function Cta21() {
    return (
        <>
            <section className="tf-section partner_CTA home3">
                <div className="overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.15)' }}>
                    <img src="/assets/images/backgroup/bg_pagetitle.png" alt="" />
                </div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8 col-md-12">
                            <div className="tf-title mb0 left" data-aos="fade-up" data-aos-duration={800}>
                                <h2 className="title mb8">
                                    Conoce más de nosotros.
                                </h2>
                                <div className="wrap-btn">
                                    <Link to="/about" className="tf-button style2">
                                        Acerca de Cerv
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 d-flex justify-content-center">
                            <div className="image">
                                <img
                                    className="img_main move5"
                                    src="/assets/cerv/home/img_partner.386d3196ee2c67c1c8b9.png"
                                    alt=""
                                    style={{
                                        height: '300px',
                                        transform: 'rotate(30deg)'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}